
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    export default Vue.extend({
        components: {
        },
        name: 'healthMaxPayment-view',
        data() {
            return {
                capital: null,
                additionalCovers: [],
                coversDetail: [],
                planName: null,
                effectDate: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                description: true,
                currentStep: 1,
                totalStep: 2,
                isAssuredTitular: false,
                dataTabHome: null,
                policyOwner: null,
                personToCover: null,
                clientCode: "0",
                originId: 2,
                localItems: [{ text: 'Inicio', path: '/salud-segura-max' },
                    { text: 'Contratar', path: '/salud-segura-max/pago' }],
                thereIsDiscount: false,
                premiumWithoutDiscount: null,
            }
        },
        methods: {
            openCancelModal: function () {
                this.$refs.cancelModal.open();
            },
            closeCancelModal: function () {
                this.$refs.cancelModal.close();
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            retry() {
                if (this.CUPEPreferenceURL == null) {
                    this.getCUPE();
                }
                this.saveEmission();
                this.showRuletaErrorModal(false);
            },
            saveEmission: function () {
                NF.UI.Page.block();
                try {
                    // Obtener datos desde sessionStorage
                    this.dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                    this.policyOwner = JSON.parse(sessionStorage.getItem("policyOwner"));
                    this.personToCover = JSON.parse(sessionStorage.getItem("personToCover"));

                    // Llamar a getSelectedProducerService.GetSelectedProducer y luego proceder con la creación del objeto
                    getSelectedProducerService.GetSelectedProducer(
                        this.clientCode,
                        parseInt(this.dataTabHome.cityId),
                        0,
                        this.originId,
                        this.dataTabHome.zipCode
                    ).then(() => {
                        let JsonEmissionData = null;
                            //Se consume el Servicio de SaveEmission con los datos correspondientes
                            let birthday = this.policyOwner.birthday;
                            if (birthday == null || birthday == undefined) {
                                birthday = "01/01/1900";
                            };
                            let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
                            let dateFormat = new Date(birthday);
                            let titular = this.policyOwner;//tomador
                            let insuranceBeneficiary = this.personToCover != null ? this.personToCover : this.policyOwner;//insuranceBeneficiary
                            let roles = {
                                clientRole: {
                                    additionalClientRole: {
                                        client: [
                                            //Titular - beneficiario
                                            {
                                                additionalClientRole: null,
                                                address: {
                                                    department: titular.address == null ? null : titular.address.department?.toString() ?? "",
                                                    floor: parseInt(titular.address == null ? null : titular.address.floor ?? 0),
                                                    streetName: titular.address == null ? "" : titular.address.streetName?.toString() ?? "",
                                                    streetNumber: titular.address == null ? "" : titular.address.numDom?.toString() ?? "",
                                                },
                                                birthday: new Date(titular.birthday),
                                                cityCode: parseInt(titular.selectedLocality != null ? titular.selectedLocality.id : this.dataTabHome.cityId),
                                                documentNumber: parseInt(titular.numDoc),
                                                documentType: titular.docTypeSelected.id.trim(),
                                                email: titular.email != null ? titular.email.toString() : null,
                                                gender: null,
                                                firstName: (titular.firstName != null && titular.firstName != "") ? titular.firstName.toString() : "",
                                                lastName: (titular.lastName != null && titular.lastName != "") ? titular.lastName.toString() : " ",
                                                phones: [{
                                                    areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                                    countryCode: null,
                                                    order: null,
                                                    phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                                    phoneType: null
                                                }],
                                                relationCode: 18, //Titular
                                                roleCode: 17, //beneficiario
                                                ivaConditionId: parseInt(titular.selectedIvaCondition.id),
                                                zipCode: titular.address != null ? titular.address.zipCode : this.dataTabHome.zipCode,
                                            },
                                            //Titular - asegurado titular
                                            {
                                                additionalClientRole: null,
                                                address: {
                                                    department: insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.department?.toString() ?? "",
                                                    floor: parseInt(insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.floor ?? 0),
                                                    streetName: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.streetName?.toString() ?? "",
                                                    streetNumber: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.numDom?.toString() ?? "",
                                                },
                                                birthday: new Date(insuranceBeneficiary.birthday),
                                                cityCode: parseInt(insuranceBeneficiary.selectedLocality != null ? insuranceBeneficiary.selectedLocality.id : this.dataTabHome.cityId),
                                                documentNumber: parseInt(insuranceBeneficiary.numDoc),
                                                documentType: insuranceBeneficiary.docTypeSelected.id.trim(),
                                                email: insuranceBeneficiary.email != null ? insuranceBeneficiary.email.toString() : null,
                                                gender: null,
                                                firstName: (insuranceBeneficiary.firstName != null && insuranceBeneficiary.firstName != "") ? insuranceBeneficiary.firstName.toString() : "",
                                                lastName: (insuranceBeneficiary.lastName != null && insuranceBeneficiary.lastName != "") ? insuranceBeneficiary.lastName.toString() : " ",
                                                phones: [{
                                                    areaCode: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? null : parseInt(insuranceBeneficiary.areaCode),
                                                    countryCode: null,
                                                    order: null,
                                                    phoneNumber: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? "" : insuranceBeneficiary.telephone.toString(),
                                                    phoneType: null
                                                }],
                                                relationCode: 18, //Titular
                                                roleCode: 36, //Asegurado Titular
                                                ivaConditionId: parseInt(insuranceBeneficiary.selectedIvaCondition.id),
                                                zipCode: insuranceBeneficiary.address != null ? insuranceBeneficiary.address.zipCode : this.dataTabHome.zipCode,
                                            },
                                        ]
                                    },
                                    address: {
                                        department: titular.address == null ? null : titular.address.department?.toString() ?? "",
                                        floor: parseInt(titular.address == null ? null : titular.address.floor ?? 0),
                                        streetName: titular.address == null ? "" : titular.address.streetName?.toString() ?? "",
                                        streetNumber: titular.address == null ? "" : titular.address.numDom?.toString() ?? "",
                                    },
                                    birthday: new Date(titular.birthday),
                                    cityCode: parseInt(titular.selectedLocality != null ? titular.selectedLocality.id : this.dataTabHome.cityId),
                                    documentNumber: parseInt(titular.numDoc),
                                    documentType: titular.docTypeSelected.id.trim(),
                                    email: titular.email != null ? titular.email.toString() : null,
                                    gender: null,
                                    firstName: (titular.firstName != null && titular.firstName != "") ? titular.firstName.toString() : "",
                                    lastName: (titular.lastName != null && titular.lastName != "") ? titular.lastName.toString() : " ",
                                    phones: [{
                                        areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                        countryCode: null,
                                        order: null,
                                        phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                        phoneType: null
                                    }],
                                    relationCode: null,
                                    roleCode: 1, //Tomador,
                                    ivaConditionId: parseInt(titular.selectedIvaCondition.id),
                                    zipCode: titular.address != null ? titular.address.zipCode : this.dataTabHome.zipCode,
                                }
                            };
                            let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
                            if (peopleToCover > 1) {
                                let familyMembers = JSON.parse(sessionStorage.getItem("familyMembers"));
                                familyMembers.forEach(familyMember => {
                                    roles.clientRole.additionalClientRole.client.push(
                                        {
                                            additionalClientRole: [{
                                                additionalClientRole: null,
                                                address: {
                                                    department: insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.department?.toString() ?? "",
                                                    floor: parseInt(insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.floor ?? 0),
                                                    streetName: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.streetName?.toString() ?? "",
                                                    streetNumber: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.numDom?.toString() ?? "",
                                                },
                                                birthday: new Date(insuranceBeneficiary.birthday),
                                                cityCode: parseInt(insuranceBeneficiary.selectedLocality != null ? insuranceBeneficiary.selectedLocality.id : this.dataTabHome.cityId),
                                                documentNumber: parseInt(insuranceBeneficiary.numDoc),
                                                documentType: insuranceBeneficiary.docTypeSelected.id.trim(),
                                                email: insuranceBeneficiary.email != null ? insuranceBeneficiary.email.toString() : null,
                                                gender: null,
                                                firstName: (insuranceBeneficiary.firstName != null && insuranceBeneficiary.firstName != "") ? insuranceBeneficiary.firstName.toString() : "",
                                                lastName: (insuranceBeneficiary.lastName != null && insuranceBeneficiary.lastName != "") ? insuranceBeneficiary.lastName.toString() : " ",
                                                phones: [{
                                                    areaCode: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? null : parseInt(insuranceBeneficiary.areaCode),
                                                    countryCode: null,
                                                    order: null,
                                                    phoneNumber: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? "" : insuranceBeneficiary.telephone.toString(),
                                                    phoneType: null
                                                }],
                                                relationCode: 18, //Titular
                                                roleCode: 36, //Asegurado Titular
                                                ivaConditionId: parseInt(insuranceBeneficiary.selectedIvaCondition.id),
                                                zipCode: insuranceBeneficiary.address != null ? insuranceBeneficiary.address.zipCode : this.dataTabHome.zipCode,
                                            }],
                                            address: {
                                                department: familyMember.address == null ? null : familyMember.address.department?.toString() ?? "",
                                                floor: parseInt(familyMember.address == null ? null : familyMember.address.floor ?? 0),
                                                streetName: familyMember.address == null ? "" : familyMember.address.streetName?.toString() ?? "",
                                                streetNumber: familyMember.address == null ? "" : familyMember.address.numDom?.toString() ?? "",
                                            },
                                            birthday: new Date(familyMember.birthday),
                                            cityCode: parseInt(familyMember.selectedLocality != null ? familyMember.selectedLocality.id : this.dataTabHome.cityId),
                                            documentNumber: parseInt(familyMember.docNum),
                                            documentType: familyMember.docType.id.trim(),
                                            email: familyMember.email != null ? familyMember.email.toString() : null,
                                            gender: null,
                                            firstName: (familyMember.firstName != null && familyMember.firstName != "") ? familyMember.firstName.toString() : "",
                                            lastName: (familyMember.lastName != null && familyMember.lastName != "") ? familyMember.lastName.toString() : " ",
                                            phones: [{
                                                areaCode: familyMember.telephone == null || familyMember.telephone == undefined || familyMember.telephone == "" ? null : parseInt(familyMember.areaCode),
                                                countryCode: null,
                                                order: null,
                                                phoneNumber: familyMember.telephone == null || familyMember.telephone == undefined || familyMember.telephone == "" ? "" : familyMember.telephone.toString(),
                                                phoneType: null
                                            }],
                                            relationCode: familyMember.relation.relationId, //familyMember
                                            roleCode: 28, //Asegurado Familiar
                                            ivaConditionId: parseInt(familyMember.selectedIvaCondition.id),
                                            zipCode: familyMember.address != null ? familyMember.address.zipCode : this.dataTabHome.zipCode,
                                        }
                                    );
                                });
                            }
                            JsonEmissionData = JSON.stringify({
                                birthday: dateFormat,
                                cityCode: this.policyOwner.address != null ? this.policyOwner.address.cityId : parseInt(this.dataTabHome.cityId),
                                clientAddress: {
                                    department: this.policyOwner.address == null ? null : this.policyOwner.address.department?.toString() ?? "",
                                    floor: parseInt(this.policyOwner.address == null ? null : this.policyOwner.address.floor ?? 0),
                                    streetName: this.policyOwner.address == null ? "" : this.policyOwner.address.streetName?.toString() ?? "",
                                    streetNumber: this.policyOwner.address == null ? "" : this.policyOwner.address.numDom?.toString() ?? "",
                                },
                                clientFirstName: (this.policyOwner.firstName != null && this.policyOwner.firstName != "") ? this.policyOwner.firstName.toString() : "",
                                clientLastName: (this.policyOwner.lastName != null && this.policyOwner.lastName != "") ? this.policyOwner.lastName.toString() : " ",
                                documentNumber: parseInt(this.policyOwner.numDoc),
                                documentType: this.policyOwner.docTypeSelected.id.trim(),
                                effectDate: planData.effectDate,
                                email: this.policyOwner.email != null ? this.policyOwner.email.toString() : null,
                                observations: null,
                                paymentType: 0,
                                phones: [{
                                    areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                    countryCode: null,
                                    order: null,
                                    phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                    phoneType: null
                                }],
                                roles: roles,
                                pricingId: parseInt(sessionStorage.getItem("selectedPricingId")),
                                zipCode: this.policyOwner.address != null ? this.policyOwner.address.zipCode : this.dataTabHome.zipCode,
                            });
                       
                        // Enviar datos de emisión
                        saveEmissionService.HealthSaveEmission(JsonEmissionData)
                            .then(response => {
                                if (!response.validationResult || response.validationResult.errorMessage === "Los datos para la emisión se guardaron correctamente") {
                                    sessionStorage.setItem("ExitOrContinueModal", "false");
                                    if (this.CUPEPreferenceURL != null) {
                                        document.getElementById("pagoIframe").setAttribute('src', this.CUPEPreferenceURL);
                                    }
                                    NF.UI.Page.unblock();
                                    return true;
                                } else {
                                    console.error("Error en respuesta de HealthSaveEmission:", response.validationResult.errorMessage);
                                    this.showRuletaErrorModal(true);
                                    NF.UI.Page.unblock();
                                    return false;
                                }
                            })
                            .catch(error => {
                                console.error("Error en HealthSaveEmission:", error);
                                this.showRuletaErrorModal(true);
                                NF.UI.Page.unblock();
                                return false;
                            });
                    }).catch(error => {
                        console.error("Error en GetSelectedProducer:", error);
                        this.showRuletaErrorModal(true);
                        NF.UI.Page.unblock();
                    });
                } catch (error) {
                    console.error("Error en saveEmission:", error);
                    this.showRuletaErrorModal(true);
                    NF.UI.Page.unblock();
                }
            }
,
            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },

            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Salud Segura Max';

                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "salud-segura-max";
                    });
            },
            getCUPE: function () {
                let productId = 321;
                let policyOwner = JSON.parse(sessionStorage.getItem("policyOwner"));
                var timeStart = new Date().getTime();
                NF.UI.Page.blockCustom({ message: "Redirigiendo al pago" });
                CUPEService.GetCUPEUrl(productId, policyOwner.email).then(response => {
                    this.CUPEPreferenceURL = response.preferenceMessage;    
                    document.getElementById('pagoIframe').addEventListener('load', () => {
                        this.loadingIframe = false;
                        var endTime = new Date().getTime();
                        var secondCharge = Math.round((endTime - timeStart) / 1000);
                        window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-checkout', 'carga': secondCharge });
                        
                    });
                })
            },
        },
        mounted() {
            this.updateByProductGoogleAnalytics();
            this.saveEmission();
            this.changeTitleAndIcon();
            this.getCUPE();
            this.thereIsDiscount = sessionStorage.getItem("thereIsDiscount") === 'true';
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            this.changeTitleAndIcon();
            let planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
            this.currentGroup = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
            let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (this.currentGroup)));
            this.coversDetail = coversCapitalAndDescription;
            let gridCovers = JSON.parse(sessionStorage.getItem("responseGetVWHealthGridCovers"));
            this.additionalCover = gridCovers.vwGridCovers.filter(item => item.gridCategoriesId === 2).map(item => {
                return {
                    coverDescription: item.coverDescription.trim()
                };
            });
            let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
            const formatDate = (dateString: string): string => {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            };

            // Asignar las fechas formateadas
            this.effectDate = formatDate(planData.effectDate);
            this.expirationDate = formatDate(planData.expirationDate);
            let group = JSON.parse(sessionStorage.getItem("groupSelected"));
            this.planName = group.name;


            if (planDataSelected != null) {
                this.DataPlan = planDataSelected!;
                this.primerCuota = this.DataPlan.premioMensual;
                this.capital = this.DataPlan.capital;
                this.premiumWithoutDiscount = this.thereIsDiscount ? this.DataPlan.premiumWithoutDiscount : null;
            }

            sessionStorage.setItem("ExitOrContinueModal", "true")
            this.currentStep = this.totalStep = parseInt(sessionStorage.getItem("totalStep"));
            this.isAssuredTitular = Boolean(sessionStorage.getItem("isAssuredTitular"));
        },
    });
